import Form from "@/shared/form/form";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import { useSuspenseQuery } from "@apollo/client";
import { BpmProcessEditorGrid } from "@/modules/admin-panel/bpm-process/shared/ui/bpm-process-editor-grid";
import {
  DYNAMIC_PROCESS_APPROVER_NOTIFICATION,
  DYNAMIC_PROCESS_INITIATOR_NOTIFICATION,
  SaveNotificationTemplateForm,
} from "@/modules/admin-panel/notification-templates/features/save-notification-template";
import { DynamicProcessInfoForm } from "./ui/save-dynamic-process-model-form/dynamic-process-info-form";
import { SaveOutlined } from "@ant-design/icons";
import { GET_DYNAMIC_PROCESS_DATA_TO_EDIT } from "./api/get-dynamic-process-data-to-edit";
import { APPROVER, INFO, INIT, useForm } from "./model/use-form";
import {
  dynamicProcessDataToDynamicProcessApproverNotificationTemplateValueInput,
  dynamicProcessDataToDynamicProcessInfoInput,
  dynamicProcessDataToDynamicProcessInitiatorNotificationTemplateValueInput,
  dynamicProcessDataToProcessRouteStepInput,
  dynamicProcessRouteHasHiddenSteps,
} from "./utils/data-transformers";
import { WithSuspense } from "@/shared/suspense";
import { PathForm } from "./ui/save-dynamic-process-model-form/path-form";

export const SaveDynamicProcessModelForm = WithSuspense(
  function SaveDynamicProcessModelForm({
    afterSubmit,
    processId,
  }: {
    afterSubmit?: () => void;
    processId?: string;
  }) {
    const { formProps, loading } = useForm({
      afterSubmit,
    });

    const { data } = useSuspenseQuery(GET_DYNAMIC_PROCESS_DATA_TO_EDIT, {
      variables: {
        processId: processId as string,
      },
      skip: !processId,
    });

    return (
      <Form.Provider {...formProps}>
        <BpmProcessEditorGrid
          processInfo={
            <DynamicProcessInfoForm
              partOf
              name={INFO}
              initialValues={
                data
                  ? dynamicProcessDataToDynamicProcessInfoInput(data)
                  : undefined
              }
            />
          }
          routeForm={
            <PathForm
              hasHiddenSteps={dynamicProcessRouteHasHiddenSteps(data)}
              initialValues={dynamicProcessDataToProcessRouteStepInput(data)}
            />
          }
          initiatorNotificationTemplate={
            <SaveNotificationTemplateForm
              name={INIT}
              partOf
              forDynamicProcess
              initialValues={dynamicProcessDataToDynamicProcessInitiatorNotificationTemplateValueInput(
                data,
              )}
              code={DYNAMIC_PROCESS_INITIATOR_NOTIFICATION}
            />
          }
          approverNotificationTemplate={
            <SaveNotificationTemplateForm
              name={APPROVER}
              partOf
              forDynamicProcess
              initialValues={dynamicProcessDataToDynamicProcessApproverNotificationTemplateValueInput(
                data,
              )}
              code={DYNAMIC_PROCESS_APPROVER_NOTIFICATION}
            />
          }
        />
        <Form>
          <SubmitWrapper>
            <SubmitButton
              icon={<SaveOutlined />}
              loading={loading}
              iconPosition="end"
            />
          </SubmitWrapper>
        </Form>
      </Form.Provider>
    );
  },
);
